import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { DashboardSidebar } from '@/layouts/dashboard';
import { Link } from 'react-router-dom';
import { t } from 'i18next';

export default function ActivitySidebar(props) {
  const { steps, currentStep, setCurrentStep, edit, courseId, moduleId } = props;

  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <nav className="notebook-sidebar__nav">
        <Link
          to={`/curso/admin/gerenciar/${courseId}/${moduleId}/atividades/d`}
          className="filter-bar__back"
        >
          <div className="card__icon-wrapper">
            <FiChevronLeft />
          </div>
          <span className="filter-back__back-container">
            <span className="filter-bar__title">{t('textsCommon.activities')}</span>
          </span>
        </Link>

        <ul className="step-by-step-nav">
          {steps.map((step, index) => {
            return (
              <li
                className={`step-by-step-nav__item ${index === currentStep ? 'active' : ''} ${currentStep > index ? 'step-by-step-nav__item--completed' : ''}`}
                onClick={() => edit && setCurrentStep(index)}
                key={index}
              >
                <Link
                  to={edit ? `/lms/criar/modulo/${step.route}` : ''}
                  className="step-by-step-nav__link"
                  style={{ cursor: edit ? 'pointer' : 'default' }}
                >
                  {step.text}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </DashboardSidebar>
  );
}
